import React from 'react'
import { Modal, Input, Typography } from 'antd'
import { splitFileNameAndExtension } from '../utils/removeFileExtension'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

/**
 * Props:
 * - visible: boolean
 * - mode: 'create' | 'rename'
 * - loading: boolean
 * - value: string
 * - onChange: (e) => void
 * - onOk: () => void
 * - onCancel: () => void
 * - okText?: string
 * - cancelText?: string
 * - title?: string
 * - placeholder?: string
 * - autoFocus?: boolean
 */
const FolderModal = ({
  visible,
  mode = 'create',
  loading = false,
  value = '',
  onChange,
  onOk,
  onCancel,
  okText,
  cancelText,
  title,
  placeholder,
  autoFocus = false,
  mediaFormat
}) => {
  const isCreate = mode === 'create'

  // Only split extension for files, not folders
  let fileName = value
  let extension = ''
  if (!isCreate && mediaFormat !== 'FOLDER') {
    const split = splitFileNameAndExtension(value)
    fileName = split.fileName
    extension = split.extension
  }

  const handleFileNameChange = e => {
    if (isCreate) {
      onChange(e)
    } else {
      if (mediaFormat === 'FOLDER') {
        onChange(e)
      } else {
        // For rename mode, combine filename with extension
        const newFileName = e.target.value
        const fullName = newFileName + extension
        onChange({ target: { value: fullName } })
      }
    }
  }

  const inputValue = isCreate ? value : fileName

  const { t } = useTranslation()

  return (
    <Modal
      centered
      title={
        title || (isCreate ? t('v5:create_new_folder') : t('v5:rename_item'))
      }
      visible={visible}
      onOk={onOk}
      okText={okText || (isCreate ? t('v2:create') : t('v4:rename'))}
      onCancel={onCancel}
      cancelText={cancelText || t('buttons:cancel')}
      okButtonProps={{ loading }}
      cancelButtonProps={{ disabled: loading }}
      closable={!loading}
      maskClosable={!loading}
    >
      <div style={{ marginBottom: 16 }}>
        <Text>
          {isCreate ? t('v5:enter_folder_name') : t('v5:enter_new_name')}
        </Text>
      </div>

      {isCreate ? (
        <Input
          placeholder={placeholder || t('v5:folder_name')}
          value={inputValue}
          onChange={handleFileNameChange}
          onPressEnter={onOk}
          disabled={loading}
          autoFocus={autoFocus}
        />
      ) : (
        <Input
          placeholder={placeholder || t('v5:new_name')}
          value={inputValue}
          onChange={handleFileNameChange}
          onPressEnter={onOk}
          disabled={loading}
          autoFocus={autoFocus}
          addonAfter={
            extension && (
              <span
                style={{
                  color: '#666',
                  fontSize: '14px',
                  userSelect: 'none'
                }}
              >
                {extension}
              </span>
            )
          }
        />
      )}
    </Modal>
  )
}

export default FolderModal
